<!-- 增加了动态绑定disabled功能 -->
<template>
	<div class="">
		<van-form>
			<StaticSingleSelect v-if="form.bq400999 == '2'" v-model="form.bs025003" label="随访名称" required :selectkey.sync="form.bs025003" :list="setList" >
				
			</StaticSingleSelect>
	<!-- 		<span v-if="form.bq400999 == '2'">{{form.bs025003}}</span> -->
			<StaticSingleSelect v-if="form.bq400999 == '1'" v-model="form.bs025003" label="随访时间"
				:selectkey.sync="form.bs025003" :list="setList" required>
			</StaticSingleSelect>
			<DateSelect v-model="form.bq400995" label="随访日期" required timeMode="defalutYear" :yearDiff="-5"></DateSelect>
			<StaticSingleSelect label="入组分类" :selectkey.sync="form.bq400998" labelProp="name" :list="userTypeList" v-show="false">
			</StaticSingleSelect>
			<FormNormalInput v-model="form.bq400997" label="备注"></FormNormalInput>
		</van-form>
		<div style="margin: 16px;">
			<van-button block type="primary" @click="SaveInfo()">
				保存
			</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		//科室表单下拉列表
		name: 'recordSetSelect',
		data() {
			return {
				form: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间
					extend1: "", //扩展字段
					extend2: "", //扩展字段
					extend3: "", //扩展字段
					extend4: "", //扩展字段
					extend5: "", //扩展字段
					bs025003: "", //随访名称
					bq400999: "1", //随访类型0-基线，1-标准时间段随访，2-不定期随访
					bq400995: "", //随访日期
					bq400996: "0", //随访状态 未提交、转换中、数据缺失、随访完成
					bq400997: "", //随访备注
					bq001018: "", //患者编号
					bq400998: 1, //当前随访分组
					bq400998Name: "",
					Bs025_003: '', //随访名称
					Bq400_999: '', //随访类型0-基线，1-标准时间段随访，2-不定期随访
					Bq400_995: '', //随访日期
					Bq400_996: '', //随访状态 未提交、转换中、数据缺失、随访完成
					Bq400_997: '', //随访备注
					Bq001_018: '', //患者编号
					Bq400_998: '', //入组类别
				},
				config: JSON.parse(sessionStorage.getItem("config")),
				setList: [{id:'治疗结束时（±7天）',name:'治疗结束时（±7天）'},{id:'停药后12周（±14天）',name:'停药后12周（±14天）'},{id:'停药后12+周化验检查',name:'停药后12+周化验检查'}],
				userTypeList: []
			}
		},
		props: {
			value: {},
			// 增加了动态绑定disabled功能
			disabled: {

			},
			// 随访类型
			recordSetType: {
				type: String,
				default: "1"
			},
			// 标准随访可选数组
			recordSetList: {
				type: Array,
				default: () => []
			},
			patientModel: {
				type: Object,
				default: () => {}
			},
			userType: {
				type: Number,
				default: 1
			}
		},
		methods: {
			// 变化默认数组格式
			changeListFormat() {
				let that = this
				that.setList = []
				that.recordSetList.forEach(function(item) {
					that.setList.push({
						id: item + "随访",
						name: item + "随访"
					})
				})
			},
			// 新增随访
			SaveInfo() {
				let that = this
				if(that.form.bs025003==''){
					that.$dialog({
						message: '请填写随访名称',
					});
					return
				}
				if(that.form.bq400995==''){
					that.$dialog({
						message: '请填写随访日期',
					});
					return
				}
				//找出下次随访周期 
				let ut = that.config.usertype.find(item=>item.id===that.form.bq400998).date//随访类型
				//找到对应的本次随访后，再找到下一次随访名称 
				let sfName = that.form.bs025003.replace('随访','')
				let sfIndex = ut.findIndex(item=>item===sfName)
				if(sfIndex>=ut.length)
				{
					that.form.extend2 =""
				}else{
					that.form.extend2 = ut[sfIndex+1].replace('周',' ')
				}	
				
				that.$utils.CopyKeySave(that.form, that.form)
				console.log(that.form)
				//保存基本信息到数据库中
				that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400/Save', that.form, function(d) {
					that.$utils.CopyKeyInfo(d.data, d.data)
					let dataModel = d.data
					that.$emit("closeAction", dataModel)
				}, null, null, null)
			}
		},
		watch: {
			value(newVal) {
				this.selectValue = newVal
			},
			recordSetList() {
				this.changeListFormat()
			},
			'form.bq400998':function(){
				// 获得当前操作所有的类型数组
				let allSetList = this.config.usertype.find(item => item.id == this.form.bq400998).date
				
				// 获得还未进行的标准随访数据
				this.recordSetList = allSetList
				if (this.recordSetType == "1") {this.form.bs025003 = ''}
				
			}
		},
		mounted: function() {
			let that = this
			this.form.bq001018 = this.patientModel.bq001018
			this.form.companyGuid = this.patientModel.companyGuid
			this.form.departmentGuid = this.patientModel.departmentGuid

			that.form.bq400999 = that.recordSetType
			// 不定期随访,固定数组
			if (that.recordSetType == "2") {
				that.form.bs025003 = ""
			}
			if (that.recordSetList.length > 0) {
				// that.changeListFormat()
			}
			that.config.usertype.forEach((item) => {
				that.userTypeList.push({
					id: item.id,
					name: item.text
				})
			})
			
			console.log(that.form.bs025003)
			this.form.bq400998 = that.userType

			// if(that.form.bq400998){
			//  let fModel = that.userTypeList.find(m=>m.id==that.form.bq400998))
			//  if(fModel){
			//   that.form.bq400998Name = fModel.name
			//  }

			// }
		}
	}
</script>

<style>
</style>
